import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { RouteAction } from "@obg/ngx.router";

import { CoreState } from "../state";

import { LastVisitedProductService } from "./last-visited-product.service";

@Injectable({
	providedIn: "root",
})
export class LastVisitedProductGuard implements CanActivate {
	private hasActivated = false;

	constructor(
		private lastVisitedProductService: LastVisitedProductService,
		private store: Store<CoreState>
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		if (this.hasActivated) {
			return true;
		}
		this.hasActivated = true;
		const routeName = this.lastVisitedProductService.getRouteName();
		if (routeName) {
			this.store.dispatch(
				RouteAction.navigate(routeName, undefined, {
					queryParams: route.queryParams,
				})
			);
			return false;
		}
		return true;
	}
}
